import getActionCounts from "./getActionCounts";
import getActionToSlot from "./getActionToSlot";
import setPendingCA from "./setPendingCA";
import setBlankCA from "./setBlankCA";
import getAction from "./getAction";

import store from "../store/index";
//-----------------------------------------------
// load specific combatant actions (and markers)
//-----------------------------------------------
export default function loadSpecificCombatantActions(
  round_actions,
  round_markers,
  idx
) {
  console.log("-----------------------------------");
  console.log("IN loadSpecificCombatantActions");
  //--------------
  // access store
  //--------------     *** NOT CALLING LAST COMB WHEN INACT EXISTS ***
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  let maxCA = this_store.config.max_ca;
  let caExtra = maxCA + 1
  //------------------------------------------------------------
  // delete vars (where action/marker num > ca i.e. ca reduced)
  //------------------------------------------------------------
  let del_actions = [];
  let del_markers = [];
  let del_actual_action_cnt = 0;
  let to_slot = 0;
  //-------------
  // id combatant
  //-------------
  let id = combatants[idx].id;
  //-------------------
  // get action counts
  //-------------------
  let counts = getActionCounts(round_actions, round_markers, combatants[idx]);
  //======================================================
  //
  // A. ACTION LOOP
  //
  //======================================================
  for (let k = 1; k <= caExtra; k++) {
    //----------
    // set vars
    //----------
    var del_parm = {};
    let ca = "ca" + k;
    let ca_name = "ca_name" + k;
    let ca_slug = "ca_slug" + k;
    let ca_type = "ca_type" + k;
    let match_action_idx = 0;
    let match_marker_idx = 0;

    console.log("====================================");
    console.log("LOOP K = " + k + " NAME = " + combatants[idx].name);
    console.log("====================================");
    //-----------------
    // ensure flag set
    //-----------------
    combatants[idx][ca_type] = "";
    //------------------------------------------------------------------
    // check action exists for specific ca number + combatant for round
    //------------------------------------------------------------------
    match_action_idx = round_actions.findIndex(function (a) {
      return a.number === k && a.combatant === id;
    });
    //==========================================================
    //
    // A1. ACTIONS
    //
    //==========================================================
    if (match_action_idx >= 0) {
      console.log(
        "got match... match_action_idx = " +
          match_action_idx +
          " name = " +
          round_actions[match_action_idx].action_name
      );
      //-------------------------------------------------------------------------
      // check action num > ca where not extra action (i.e. ca has been reduced)
      //-------------------------------------------------------------------------
      if (k > combatants[idx].ca && k != caExtra) {
        console.log(
          "ADDING ACTION DELETION - k = " +
            k +
            " > ca = " +
            combatants[idx].ca +
            " name = " +
            round_actions[match_action_idx].slug
        );
        //----------------------------------
        // increment cnt if action = actual
        //----------------------------------
        let a = getAction(round_actions[match_action_idx].action_name);
        if (a.actual) {
          del_actual_action_cnt++;
        }
        //--------------
        // set del parm
        //--------------
        del_parm = {
          id: combatants[idx].id,
          slug: round_actions[match_action_idx].slug,
          slot: "Action",
          num: k,
          actual: a.actual,
          marker_name: "",
          notify: false,
        };
        //----------------------------
        // store action to be deleted
        //----------------------------
        del_actions.push(del_parm);
        //
      } else {
        //-------------------
        // else action <= ca
        //-------------------
        console.log(
          "setting action... k = " +
            k +
            " name = " +
            round_actions[match_action_idx].action_name
        );
        combatants[idx][ca] = round_actions[match_action_idx].action_image;
        combatants[idx][ca_name] = round_actions[match_action_idx].action_name;
        combatants[idx][ca_slug] = round_actions[match_action_idx].slug;
        combatants[idx][ca_type] = "action";
      }
      //---------------------------------------------------------------
      // check marker exists for specific ca num + combatant for round
      //---------------------------------------------------------------
    } else {
      match_marker_idx = round_markers.findIndex(function (a) {
        return a.number === k && a.combatant === id;
      });
      //==========================================================
      //
      // A2. MARKERS
      //
      //==========================================================
      if (match_marker_idx >= 0) {
        // console.log(
        //   "got match... match_marker_idx = " +
        //     match_marker_idx +
        //     " name = " +
        //     round_markers[match_marker_idx].marker_name
        // );
        //--------------------------------------------------
        // check action num > ca (i.e. ca has been reduced)
        //--------------------------------------------------
        if (k > combatants[idx].ca) {
          // console.log(
          //   "ADDING MARKER DELETION - k = " +
          //     k +
          //     " > ca = " +
          //     combatants[idx].ca
          // );
          //--------------
          // set del parm
          //--------------
          del_parm = {
            id: combatants[idx].id,
            slug: round_markers[match_marker_idx].slug,
            slot: "Marker",
            num: k,
            actual: false,
            marker_name: round_markers[match_marker_idx].marker_name,
            notify: false,
          };
          //----------------------------
          // store marker to be deleted
          //----------------------------
          del_markers.push(del_parm);
          //
        } else {
          //-------------------
          // else marker <= ca
          //-------------------
          combatants[idx][ca] = round_markers[match_marker_idx].marker_image;
          combatants[idx][ca_name] =
            round_markers[match_marker_idx].marker_name;
          combatants[idx][ca_slug] = round_markers[match_marker_idx].slug;
          combatants[idx][ca_type] = "marker";
        }
      }
    }
    //======================================================
    //
    // B. MAINTAIN COUNTS
    //
    //======================================================
    combatants[idx].action_count = counts.action_count - del_actions.length;
    combatants[idx].marker_count = counts.marker_count - del_markers.length;
    combatants[idx].actual_action_count =
      counts.actual_action_count - del_actual_action_cnt;

    // console.log("-------------------------");
    // console.log("del_actions.length = " + del_actions.length);
    // console.log("del_markers.length = " + del_markers.length);
    // console.log("del_actual_action_cnt = " + del_actual_action_cnt);
    // console.log("-------------------------");
    // console.log("action_count = " + combatants[idx].action_count);
    // console.log("marker_count = " + combatants[idx].marker_count);
    // console.log("actual_action_count = " + combatants[idx].actual_action_count);
    // console.log("-------------------------");
    //======================================================
    //
    // C. NO ACTION/MARKER FOR SLOT
    //
    //======================================================s
    if (combatants[idx][ca_type] == "") {
      console.log("-------------------------");
      console.log("Blank slot...");
      //--------------
      // calc to-slot
      //--------------
      if (to_slot == 0) {
        to_slot = getActionToSlot(
          combatants[idx].ca,
          combatants[idx].actual_action_count,
          combatants[idx].action_count
        );
        console.log("new to_slot = " + to_slot);
      }
      //---------------
      // set slot parm
      //---------------
      let slot_parm = {
        id: id,
        ca_num: k,
      };
      //==============================================
      // C1. PENDING
      //-------------
      if (k <= to_slot) {
        // console.log("A. k <= to slot .. k = " + k + " to_slot = " + to_slot);
        //----------------------------------
        // where:
        // a) no deletion or
        // b) no action for ca -> set blank
        //----------------------------------
        if (!del_parm || match_action_idx == -1) {
          // console.log("A1. k = " + k + " -> pending");
          setPendingCA(slot_parm);
        } else {
          //--------------------------------------
          // where deletion - remove action entry
          //--------------------------------------
          let del_action_idx = del_actions.findIndex((a) => a.num == k);
          if (del_action_idx >= 0) {
            // console.log(
            //   "removing action entry ca = " + k + " at idx = " + del_action_idx
            // );
            del_actions.splice(del_action_idx, 1);
            //--------------------------------------------
            // having removed deletion entry - set action
            //--------------------------------------------
            // console.log(
            //   "A2. setting action... k = " +
            //     k +
            //     " name = " +
            //     round_actions[match_action_idx].action_name
            // );
            combatants[idx][ca] = round_actions[match_action_idx].action_image;
            combatants[idx][ca_name] =
              round_actions[match_action_idx].action_name;
            combatants[idx][ca_slug] = round_actions[match_action_idx].slug;
            combatants[idx][ca_type] = "action";
          } else {
            //--------------------------------------
            // where deletion - remove marker entry
            //--------------------------------------
            let del_marker_idx = del_markers.findIndex((a) => a.num == k);
            if (del_marker_idx >= 0) {
              // console.log(
              //   "removing marker entry ca = " +
              //     k +
              //     " at idx = " +
              //     del_marker_idx
              // );
              del_markers.splice(del_marker_idx, 1);
              //--------------------------------------------
              // having removed deletion entry - set marker
              //--------------------------------------------
              // console.log(
              //   "A3. setting marker... k = " +
              //     k +
              //     " name = " +
              //     round_markers[match_marker_idx].marker_name
              // );
              combatants[idx][ca] =
                round_markers[match_marker_idx].marker_image;
              combatants[idx][ca_name] =
                round_markers[match_marker_idx].marker_name;
              combatants[idx][ca_slug] = round_markers[match_marker_idx].slug;
              combatants[idx][ca_type] = "marker";
            } else {
              //---------
              // error!!
              //---------
              alert("unable to locate deletion entry k = " + k);
            }
          }
        }
      } else {
        //==============================================
        // C2. BLANK
        //-----------
        console.log(
          "C2. k <= to slot .. k = " +
            k +
            " to_slot = " +
            to_slot +
            " slot = " +
            del_parm.slot)
        console.log("k = " + k + " -> blank");
        setBlankCA(slot_parm);
      }
    }
  }
  //======================================================
  //
  // D. RETURN DELETION ARRAYS
  //
  //======================================================
  let return_dels = {
    actions: del_actions,
    markers: del_markers,
  };
  return return_dels;
}
